module.exports = __webpack_public_path__ + "img/london_oak_bfusa_list.e27ad734.jpg";